
import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/components/ui/sheet";
import {
  HomeIcon, SettingsIcon, KeyIcon, BarChartIcon, 
  SparklesIcon, ZapIcon, LayersIcon, MenuIcon,
  PlayIcon, DatabaseIcon, BookOpenIcon
} from "lucide-react";

export function MobileNav() {
  const [open, setOpen] = useState(false);
  
  const platformNavigation = [
    { name: "Dashboard", href: "/", icon: HomeIcon },
    { name: "Playground", href: "/playground", icon: PlayIcon },
    { name: "Fine-tuning", href: "/fine-tuning", icon: SparklesIcon },
    { name: "Datasets", href: "/datasets", icon: DatabaseIcon },
    { name: "API Keys", href: "/api-keys", icon: KeyIcon },
    { name: "Integrations", href: "/integrations", icon: ZapIcon },
  ];
  
  const settingsNavigation = [
    { name: "Team", href: "/team", icon: SettingsIcon },
    { name: "Usage & Billing", href: "/analytics", icon: BarChartIcon },
    { name: "Settings", href: "/settings", icon: SettingsIcon },
  ];

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="ml-auto">
          <MenuIcon className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="bg-neutral-50 dark:bg-neutral-900 p-0">
        <div className="flex items-center h-16 border-b border-neutral-200 dark:border-neutral-800 pl-6">
          <div className="flex items-center gap-2">
            <LayersIcon className="h-6 w-6 text-primary" />
            <span className="text-lg font-semibold text-foreground font-space">
              LLM Gateway
            </span>
          </div>
        </div>
        
        {/* Platform Section */}
        <div className="px-4 py-6">
          <h3 className="text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider mb-3 pl-3">
            Platform
          </h3>
          <div className="flex flex-col gap-1">
            {platformNavigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setOpen(false)}
                className="flex items-center gap-3 px-3 py-2 rounded-md text-neutral-600 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800"
              >
                <item.icon className="h-5 w-5 text-neutral-400 dark:text-neutral-500" />
                <span className="font-space text-sm">{item.name}</span>
              </Link>
            ))}
          </div>
        </div>
        
        {/* Settings Section */}
        <div className="px-4 pt-4">
          <h3 className="text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider mb-3 pl-3">
            Settings
          </h3>
          <div className="flex flex-col gap-1">
            {settingsNavigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setOpen(false)}
                className="flex items-center gap-3 px-3 py-2 rounded-md text-neutral-600 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800"
              >
                <item.icon className="h-5 w-5 text-neutral-400 dark:text-neutral-500" />
                <span className="font-space text-sm">{item.name}</span>
              </Link>
            ))}
          </div>
        </div>
        
        {/* Docs Link */}
        <div className="mt-6 px-4 py-6">
          <Link
            to="/docs"
            onClick={() => setOpen(false)}
            className="flex items-center gap-3 px-3 py-2 rounded-md text-neutral-600 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800"
          >
            <BookOpenIcon className="h-5 w-5 text-neutral-400 dark:text-neutral-500" />
            <span className="font-space text-sm">Documentation</span>
          </Link>
        </div>
      </SheetContent>
    </Sheet>
  );
}
